import axios from "../axios-init";

export const getBoxSizeList = params => {
    return axios.post(`/boxsizes/getBoxSizeList`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const editBoxSize = params => {
    return axios.post(`/boxsizes/saveOrUpdateById`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const getBoxSizeById = params => {
    return axios.post(`/boxsizes/getBoxSizeById`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};



// WEBPACK FOOTER //
// ./src/api/boxsizeService.js